module Meevo.Components.Controls.SmartMover {
    import EmployeeCategory = Model.EmployeeCategory;


    export class EmployeeCategoriesCollection extends SmartMoverApiCollection<EmployeeCategory> implements IApiCollection<EmployeeCategory> {

        get url() {
            return 'EmployeeCategory';
        }
    }

}
